module.exports = __webpack_public_path__ + "static/media/downArrowIcon.1e7e6a6a.svg";